import { useLocation, useNavigate } from 'react-router-dom';
import { KitTemplatesPage } from './KitTemplatesPage';
import { KitsListPage } from './KitsListPage';

type KittingSection = 'Kits' | 'Templates';

const SECTIONS: readonly KittingSection[] = ['Kits', 'Templates'];

function sectionFromPath(pathname: string): KittingSection {
  return pathname.startsWith('/kitting/templates') ? 'Templates' : 'Kits';
}

export function KittingPage(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const section = sectionFromPath(location.pathname);

  return (
    <div>
      <h2>Kitting</h2>
      <div className="tcvs-storage-layout">
        <nav className="tcvs-storage-nav" aria-label="Kitting sections">
          <div className="tcvs-storage-nav-group">
            <div className="tcvs-storage-nav-heading">Kitting</div>
            {SECTIONS.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => navigate(item === 'Templates' ? '/kitting/templates' : '/kitting')}
                aria-current={item === section ? 'page' : undefined}
                className={
                  item === section
                    ? 'tcvs-storage-nav-item tcvs-storage-nav-item-active'
                    : 'tcvs-storage-nav-item'
                }
              >
                {item}
              </button>
            ))}
          </div>
        </nav>
        <div className="tcvs-storage-content">
          {section === 'Kits' ? <KitsListPage /> : null}
          {section === 'Templates' ? <KitTemplatesPage /> : null}
        </div>
      </div>
    </div>
  );
}
